import { type SpotPrice } from "@nodus/api";
import { type OfferingLike } from "@nodus/ui";

export type SpotHardware = OfferingLike & { spotQuote: SpotPrice };
export const spotQuote = (choice?: OfferingLike): SpotPrice | undefined => (choice as Partial<SpotHardware> | undefined)?.spotQuote;
export const accessLabel = (choice?: OfferingLike) => spotQuote(choice) ? (spotQuote(choice)?.execution_environment === "container" ? "Direct SSH · GPU container" : "Direct SSH · whole VM") : "Managed terminal, VS Code & Jupyter";

/** Quote choices are local display data; their IDs are never sent to Workspace admission. */
export function spotHardware(prices: readonly SpotPrice[]): SpotHardware[] {
  return prices.map((quote) => ({
    metadata: { name: `quote-${quote.region}-${quote.gpu}` },
    spec: { category: "GPU", accelerator: { id: quote.gpu.startsWith("mi300") ? "MI300X" : quote.gpu.startsWith("h200") ? "H200" : "H100", family: quote.gpu.startsWith("mi300") ? "MI300X" : quote.gpu.startsWith("h200") ? "H200" : "H100", displayName: quote.gpu.startsWith("mi300") ? "MI300X" : quote.gpu.startsWith("h200") ? "H200" : "H100", memory: quote.gpu.startsWith("mi300") ? "192Gi" : quote.gpu.startsWith("h200") ? "141Gi" : "80Gi" }, count: quote.gpus, regionClass: quote.region, interruptible: true },
    status: { priceUSDPerHour: { from: String(quote.price_per_node_hr) } },
    spotQuote: quote,
  }));
}
